import React, {useState} from 'react';
import {Carousel} from 'react-bootstrap';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {
  setSelectedBu,
  setCustomerCardModalTrigger,
  setTitular,
  setIban,
} from '../../../../../../store/actions';
import colors from '../../../../../../util/colors';
import * as fonts from '../../../../../../util/fonts';
import Icon from '../../../../../icon';
import {Icons} from '../../../../../../util/icons';
import ModalTemplate from '../../../../../modal';
import {Column, Row} from '../../../../../layout';
import _ from 'lodash';
import AppSelectInput from '../../../../../input/app-select-input';
import AppCheckboxInput from '../../../../../input/app-checkbox-input';
import './styles.scss';
import {strings} from '../../../../../../util/strings';
import AppButton from '../../../../../app-button';
import {useHistory} from 'react-router';
import {uriGetServices, uriGetTitular} from '../../../../../../api/endpoints';
import {get} from '../../../../../../api/api';

interface CustomerCardSelectorModalProps {
  show: boolean;
  setShow(value: boolean): any;
  items: any;
  currentStyles: any;
  activeIndex: any;
  handleSelect(value: any): any;
  stagedBu: any;
  insuranceOptions: any;
  setStagedBu(value: any): any;
  setItems(value: any): any;
  setTitular(value: any): any;
  activeModalIndex: any;
  setActiveModalIndex(value: any): any;
  busMap: any;
  busFuncMap: any;
  selectedBu: any;
  setCustomerCardModalTrigger(value: any): void;
  setIban(value: any): void;
  messageStrings: typeof strings.pt.messages;
  confirmLabels: typeof strings.pt.register;
  appointmentsStrings: typeof strings.pt.appointments;
  bankAccountDataHolder: any;
}

const CustomerCardSelectorModal = ({
  show,
  setShow,
  items,
  currentStyles,
  activeIndex,
  handleSelect,
  stagedBu,
  insuranceOptions,
  setStagedBu,
  setItems,
  setIban,
  activeModalIndex,
  setActiveModalIndex,
  setCustomerCardModalTrigger,
  setTitular,
  busMap,
  busFuncMap,
  selectedBu,
  messageStrings,
  confirmLabels,
  appointmentsStrings,
  bankAccountDataHolder,
}: CustomerCardSelectorModalProps) => {
  const history = useHistory();
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [buTochangeInto, setBuTochangeInto] = useState('');
  const [noAccessToFuncError, setNoAccessToFuncError] = useState(false);
  const insuranceSelectorLabel =
    stagedBu.card && stagedBu.card.cardDetail
      ? `${stagedBu.card.cardDetail.cardNbr}`
      : '';

  const featureName = 'CardSelector';
  const handleModalSelect = (selectedIndex: any) => {
    setActiveModalIndex(selectedIndex);
  };

  const handleInsuranceOnChange = (value: any) => {
    setBuTochangeInto(value);

    if (
      window.location.pathname.includes('pedido-reembolso') ||
      window.location.pathname.includes('pedido-pre-autorizacao')
    ) {
      //if in refund or pre auth request, triggers the 'lose progress/goback modal'
      setNoAccessToFuncError(false);
      setShow(false);
      setOpenConfirmationModal(true);
    } else if (window.location.pathname.includes('consultas-online')) {
      //if in appointments, check more stuff:
      redirectIfNotHasPermissions(value);
    } else {
      changeInsurance(value);
    }
  };

  const redirectIfNotHasPermissions = (buToChange: string) => {
    const selectedMember = JSON.parse(buToChange);
    get(
      uriGetServices(
        selectedMember.buId,
        selectedMember.prdNbr,
        selectedMember.benNbr
      ),
      false,
      0,
      featureName
    ).then((res: any) => {
      const aux = res?.data?.items?.find((el: any) => el.isMedicoOnline);
      if (!aux) {
        //bu to change doesnt have permissions for this func so its redirected to homepage
        setNoAccessToFuncError(true);
        setShow(false);
        setOpenConfirmationModal(true);
      } else {
        if (window.location.pathname.includes('marcar-consulta')) {
          //bu to change has permissions for this func but since we are in a request, triggers request will belost/goback modal
          setNoAccessToFuncError(false);
          setShow(false);
          setOpenConfirmationModal(true);
        } else {
          //bu to change has permissions to func and we are in appointments history so just changed bu and loads new history
          changeInsurance(buToChange);
        }
      }
    });
  };

  const getTitular = async (selectedMember: any) => {
    try {
      let titular: any = await get(
        uriGetTitular(selectedMember.buId, selectedMember.famId)
      );
      if (titular) {
        setTitular(titular);
        setIban(titular.iban);
      } else {
        setTitular({});
        setIban({});
      }
    } catch (err: any) {
      setTitular({});
      setIban({});
    }
  };

  const changeInsurance = (bu?: string) => {
    var buToChange;
    bu ? (buToChange = bu) : (buToChange = buTochangeInto);

    const selectedMember = JSON.parse(buToChange);
    const newItems = busMap[selectedMember.buId][selectedMember.famId];

    setSelectedBu(selectedMember);
    setStagedBu(selectedMember);
    setItems(newItems);
  };

  const renderDirectionModalIcons = (
    direction: string,
    onlyMobile: boolean
  ) => {
    const handleMobileDirectionIconsOnClick = (e: any) => {
      e.preventDefault();
      let newIndex =
        direction === 'prev' ? activeModalIndex - 1 : activeModalIndex + 1;
      if (newIndex < 0) {
        newIndex = items.length - 1;
      }
      if (newIndex > items.length - 1) {
        newIndex = 0;
      }

      handleModalSelect(newIndex);
    };

    return (
      items.length > 1 && (
        <div
          onClick={(e) =>
            onlyMobile ? handleMobileDirectionIconsOnClick(e) : null
          }
          className={`app-header-card-change-container ${
            onlyMobile &&
            'card-details-change-container card-change-icon-responsive'
          }`}>
          <Icon
            name={
              direction === 'prev' ? Icons.CHEVRON_LEFT : Icons.CHEVRON_RIGHT
            }
            color={currentStyles?.primaryColor || colors.blue}
            className={`app-header-card-change-icon`}
          />
        </div>
      )
    );
  };

  const renderInsuranceSelector = () => (
    <>
      <Row className="card-details-title">
        {messageStrings?.card_selector_title}
      </Row>
      <Row className="card-details-insurance-label" style={{...fonts.SM}}>
        {messageStrings?.card_selector_subtitle}
      </Row>
      <Row className="card-details-insurance-input-row">
        <Column
          className="card-details-insurance-input-selected-label insurance-selector"
          style={{...fonts.M}}>
          <div className="card-details-stage-bu-name">
            {_.toUpper(stagedBu.buName)}
          </div>
          <div>{insuranceSelectorLabel}</div>
        </Column>
        <AppSelectInput
          className="card-details-insurance-input"
          value={JSON.stringify(stagedBu)}
          options={insuranceOptions}
          onChange={(value) => handleInsuranceOnChange(value)}
        />
      </Row>
    </>
  );

  const renderCarouselModalItem = (item: any, index: any, card: boolean) => {
    const borderStyle =
      index === activeIndex
        ? `solid 5px ${currentStyles?.primaryColor || colors.blue}`
        : 'solid 5px transparent';

    const cardBackground = currentStyles?.primaryColor || colors.blue;

    const displayCardMemberName =
      (item.card && item.card.cardDetail && item.card.cardDetail.name) ||
      item.memberName;

    const displayCardNumber =
      item.card && item.card.cardDetail && item.card.cardDetail.cardNbr;

    return (
      <Carousel.Item key={index}>
        <Column
          style={{
            border: borderStyle,
          }}
          className={
            index === activeIndex
              ? 'card-details-card-image-selected'
              : 'card-details-no-class'
          }>
          <AppCheckboxInput
            className="card-details-card-image-checkbox"
            checked={index === activeIndex}
            disabled={index === activeIndex}
            onChange={() => {}}
            onClick={() => {
              handleModalSelect(index);
              handleSelect(index);
            }}
            label={''}
          />
          {card ? (
            <>
              <img
                src={`data:image/png;charset=utf-8;base64, ${item.card.cardImage}`}
                alt=""
                className="card-details-card-image"
              />
              {item.card.cardImageBack && (
                <img
                  src={`data:image/png;charset=utf-8;base64, ${item.card.cardImageBack}`}
                  alt=""
                  className="card-details-card-image"
                />
              )}
            </>
          ) : (
            <>
              <div
                style={{
                  background: cardBackground,
                }}
                className="placeholder-card card-details-card-image">
                <div>{displayCardMemberName}</div>
                <div>{displayCardNumber}</div>
              </div>
              <div
                style={{
                  background: cardBackground,
                }}
                className="placeholder-card card-details-card-image"></div>
            </>
          )}
        </Column>
      </Carousel.Item>
    );
  };

  const renderCarouselModalItems = () =>
    items.map((item: any, index: any) => {
      const hasCard = !!(item.card && item.card.cardImage);
      return renderCarouselModalItem(item, index, hasCard);
    });

  const renderCustomizedModalIndicators = () => {
    return (
      items.length > 1 && (
        <ol className="carousel-indicators">
          {items.map((item: any, index: any) => (
            <li
              key={index}
              onClick={() => {
                handleModalSelect(index);
              }}
              className={index === activeModalIndex ? 'active' : ''}
              style={{
                backgroundColor:
                  index === activeModalIndex && currentStyles.primaryColor,
              }}
            />
          ))}
        </ol>
      )
    );
  };

  const renderInsuranceMemberCarousel = () => (
    <Row className="card-details-card-change">
      <Column className="card-details-card-change-column">
        <Row className="card-change-container-responsive">
          {renderDirectionModalIcons('prev', true)}
          <div style={{...fonts.SM}}>{messageStrings?.card_selector_title}</div>
          {renderDirectionModalIcons('next', true)}
        </Row>
        <Carousel
          activeIndex={activeModalIndex}
          onSelect={handleModalSelect}
          interval={null}
          className="card-details-carousel-container"
          indicators={false}
          prevIcon={renderDirectionModalIcons('prev', false)}
          nextIcon={renderDirectionModalIcons('next', false)}>
          {renderCarouselModalItems()}
        </Carousel>
        {renderCustomizedModalIndicators()}
      </Column>
    </Row>
  );

  const userConfirmation = () => {
    changeInsurance();
    setOpenConfirmationModal(false);
    !noAccessToFuncError && setShow(true);
    noAccessToFuncError ? window.location.replace('/inicio') : history.goBack();
  };

  const renderChangeBuConfirmationModal = () => {
    return (
      <ModalTemplate
        type="error"
        className="change-middle-request-modal"
        show={openConfirmationModal}
        onHide={() => {
          setOpenConfirmationModal(false);
          setShow(true);
        }}
        hideFooter={true}
        cross={true}
        title={messageStrings?.changeBuMiddleRequestTitle}>
        <p className="warningText">
          {noAccessToFuncError
            ? appointmentsStrings?.appointments_error_bu_func
            : messageStrings?.changeBuMiddleRequest}
        </p>
        <Row className="want-to-register-button-row">
          {!noAccessToFuncError && (
            <>
              <AppButton
                className="want-to-register-button"
                variant="secondary"
                onClick={() => {
                  setOpenConfirmationModal(false);
                  setShow(true);
                }}>
                {confirmLabels?.register_no}
              </AppButton>
              <Column className="pl-4 pr-4"></Column>
              <AppButton
                className="want-to-register-button"
                variant="primary"
                onClick={() => {
                  userConfirmation();
                }}>
                {confirmLabels?.register_yes}
              </AppButton>
            </>
          )}
          {noAccessToFuncError && (
            <AppButton
              className="want-to-register-button"
              variant="secondary"
              onClick={() => {
                userConfirmation();
              }}>
              {appointmentsStrings?.appointments_understood}
            </AppButton>
          )}
        </Row>
      </ModalTemplate>
    );
  };

  return (
    <>
      <ModalTemplate
        inputType="noInput"
        show={show}
        cross={true}
        onHide={() => {
          setShow(false);
          setCustomerCardModalTrigger({showCardSelector: false});
        }}
        className="card-details-modal">
        {renderInsuranceSelector()}
        {renderInsuranceMemberCarousel()}
      </ModalTemplate>
      {renderChangeBuConfirmationModal()}
    </>
  );
};

const mapStateToProps = ({
  busMap,
  strings,
  busFuncMap,
  selectedBu,
  bankAccountDataHolder,
}: any) => ({
  busMap: busMap.value,
  messageStrings: strings.value.pt.messages,
  confirmLabels: strings.value.pt.register,
  appointmentsStrings: strings.value.pt.appointments,
  busFuncMap: busFuncMap.value,
  selectedBu: selectedBu.value,
  bankAccountDataHolder: bankAccountDataHolder.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setSelectedBu: (value: any) => dispatch(setSelectedBu(value)),
  setCustomerCardModalTrigger: (value: any) =>
    dispatch(setCustomerCardModalTrigger(value)),
  setTitular: (value: any) => dispatch(setTitular(value)),
  setIban: (value: any) => dispatch(setIban(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(CustomerCardSelectorModal)
);
